module.exports = __webpack_public_path__ + "static/media/icon_forecast.3a68a283.svg";